/* StadiumBlok Configurator (SCF)
   Select stadiums -> live bundle price -> optional engraved plaque (per stadium) -> add to cart.
   Bundle discount enforced by native automatic discounts; plaque = "Engraved Plaque" add-on product. */
(function () {
  'use strict';

  var SYMBOLS = { EUR: '€', USD: '$', GBP: '£' };
  function money(cents, cfg) {
    var sym = SYMBOLS[cfg.currency] || cfg.currency;
    return (cents / 100).toFixed(2).replace('.', ',') + ' ' + sym;
  }
  function discountPercent(count, rules) {
    var pct = 0;
    rules.forEach(function (r) {
      if (count >= r.min && (r.max === 0 || count <= r.max)) pct = r.percent;
    });
    return pct;
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function ordinalLabel(nextIndex, rules, i18n) {
    var ords = (i18n.ordinals || '2ND,3RD,4TH,5TH,6TH,7TH,8TH').split(',');
    var word = ords[nextIndex - 2] || String(nextIndex);
    var pct = discountPercent(nextIndex, rules);
    var label = (i18n.addStadium || '+ ADD [ord] STADIUM').replace('[ord]', word);
    if (pct) label += (i18n.saveSuffix || ' – SAVE [pct]%').replace('[pct]', pct);
    return label;
  }
  function setVal(input, v) {
    var d = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    d.call(input, v);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  // Locale-aware base path ("/" on default locale, "/it/" on Italian, etc.).
  // Keeps cart/checkout on the visitor's language instead of reverting to default.
  var CART_BASE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function SCF(root) {
    var cfg = JSON.parse(root.getAttribute('data-config'));
    var catalog = JSON.parse(root.querySelector('.scf-catalog').textContent || '[]');
    var i18nEl = root.querySelector('.scf-i18n');
    var i18n = {};
    try { i18n = JSON.parse(i18nEl ? i18nEl.textContent : '{}') || {}; } catch (e) { i18n = {}; }
    var plaqueCfg = cfg.plaque || {};
    var plaqueAvailable = plaqueCfg.variantId && plaqueCfg.variantId > 0;

    var slotsEl = root.querySelector('[data-scf-slots]');
    var addsEl = root.querySelector('[data-scf-adds]');
    var plaqueEl = root.querySelector('[data-scf-plaque]');
    var priceEl = root.querySelector('[data-scf-price]');
    var atcEl = root.querySelector('[data-scf-atc]');
    var errEl = root.querySelector('[data-scf-err]');
    var modal = root.querySelector('[data-scf-modal]');
    var modalBody = root.querySelector('[data-scf-modal-body]');

    function freshEng() { return { h: '', s: '' }; }
    var state = [Object.assign({ locked: true, eng: freshEng() }, cfg.first)];
    var plaqueOn = false;

    function totalBase() { return state.reduce(function (s, x) { return s + x.price; }, 0); }
    function stadiumTotal() {
      var sub = totalBase();
      var pct = discountPercent(state.length, cfg.discountRules);
      return Math.round(sub * (100 - pct) / 100);
    }
    function plaqueTotal() { return plaqueOn && plaqueAvailable ? plaqueCfg.price * state.length : 0; }

    /* ---------- slots ---------- */
    function renderSlots() {
      slotsEl.innerHTML = '';
      state.forEach(function (item, i) {
        var row = el('div', 'scf-slot');
        if (item.image) {
          var img = el('span', 'scf-slot__thumb');
          img.style.backgroundImage = 'url(' + item.image + ')';
          row.appendChild(img);
        }
        row.appendChild(el('span', 'scf-slot__name', item.title));
        if (!item.locked) {
          var rm = el('button', 'scf-slot__remove', '×');
          rm.type = 'button';
          rm.setAttribute('aria-label', (i18n.remove || 'Remove [title]').replace('[title]', item.title));
          rm.addEventListener('click', function () { state.splice(i, 1); render(); });
          row.appendChild(rm);
        }
        slotsEl.appendChild(row);
      });
    }

    /* ---------- add button + picker ---------- */
    function renderAdds() {
      addsEl.innerHTML = '';
      var addBtn = el('button', 'scf-add', ordinalLabel(state.length + 1, cfg.discountRules, i18n));
      addBtn.type = 'button';
      addBtn.addEventListener('click', function () { openPicker(addBtn); });
      addsEl.appendChild(addBtn);
    }
    function openPicker(anchor) {
      closePicker();
      var pop = el('div', 'scf-picker');
      pop.setAttribute('data-scf-picker', '');
      var search = el('input', 'scf-picker__search');
      search.type = 'text';
      search.placeholder = i18n.searchPlaceholder || 'Search stadium...';
      var list = el('div', 'scf-picker__list');
      pop.appendChild(search); pop.appendChild(list);
      function paint(q) {
        list.innerHTML = '';
        catalog.filter(function (s) { return s.available !== false && s.price > 0; })
          .filter(function (s) { return !q || s.title.toLowerCase().indexOf(q.toLowerCase()) > -1; })
          .forEach(function (s) {
            var opt = el('button', 'scf-picker__opt'); opt.type = 'button';
            if (s.image) { var t = el('span', 'scf-picker__thumb'); t.style.backgroundImage = 'url(' + s.image + ')'; opt.appendChild(t); }
            opt.appendChild(el('span', 'scf-picker__name', s.title));
            opt.addEventListener('click', function () {
              state.push({ handle: s.handle, title: s.title, variantId: s.variantId, price: s.price, image: s.image, eng: freshEng() });
              closePicker(); render();
            });
            list.appendChild(opt);
          });
        if (!list.children.length) list.appendChild(el('div', 'scf-picker__empty', i18n.noMatches || 'No matches'));
      }
      search.addEventListener('input', function () { paint(search.value); });
      paint('');
      anchor.parentNode.appendChild(pop);
      search.focus();
      setTimeout(function () { document.addEventListener('click', outside); }, 0);
      function outside(e) { if (!pop.contains(e.target) && e.target !== anchor) closePicker(); }
      pop._outside = outside;
    }
    function closePicker() {
      var p = root.querySelector('[data-scf-picker]');
      if (p) { if (p._outside) document.removeEventListener('click', p._outside); p.remove(); }
    }

    /* ---------- plaque section ---------- */
    function renderPlaque() {
      plaqueEl.innerHTML = '';
      if (!plaqueAvailable) return;
      plaqueEl.appendChild(el('div', 'scf-plaque__head', i18n.engravedPlaque || 'ENGRAVED PLAQUE'));
      var opts = el('div', 'scf-plaque__opts');
      var yes = el('button', 'scf-plaque__opt' + (plaqueOn ? ' is-active' : ''),
        '<strong>' + (i18n.plaque || 'PLAQUE') + '</strong><span>' + (i18n.plaqueDesc || 'Custom engraving · +[amount] each').replace('[amount]', money(plaqueCfg.price, cfg)) + '</span>');
      yes.type = 'button';
      var no = el('button', 'scf-plaque__opt' + (!plaqueOn ? ' is-active' : ''), '<strong>' + (i18n.noPlaque || 'NO PLAQUE') + '</strong>');
      no.type = 'button';
      yes.addEventListener('click', function () { plaqueOn = true; render(); openModal(); });
      no.addEventListener('click', function () { plaqueOn = false; render(); });
      opts.appendChild(yes); opts.appendChild(no);
      plaqueEl.appendChild(opts);
      if (plaqueOn) {
        var cz = el('button', 'scf-plaque__customize', i18n.customizePreview || 'CUSTOMIZE &amp; PREVIEW');
        cz.type = 'button';
        cz.addEventListener('click', openModal);
        plaqueEl.appendChild(cz);
      }
    }

    /* ---------- engraving modal ---------- */
    function plaquePreviewEl(item) {
      var pv = el('div', 'scf-plaque-preview');
      pv.innerHTML =
        '<span class="scf-plaque-preview__h"></span>' +
        '<span class="scf-plaque-preview__s"></span>';
      paintPreview(pv, item);
      return pv;
    }
    function paintPreview(pv, item) {
      pv.querySelector('.scf-plaque-preview__h').textContent = item.eng.h || item.title.toUpperCase();
      var sub = pv.querySelector('.scf-plaque-preview__s');
      sub.textContent = item.eng.s || '';
      sub.style.display = item.eng.s ? '' : 'none';
    }
    function openModal() {
      if (!plaqueAvailable) return;
      modalBody.innerHTML = '';
      state.forEach(function (item) {
        var block = el('div', 'scf-eng');
        block.appendChild(el('div', 'scf-eng__title', item.title));
        var pv = plaquePreviewEl(item);
        block.appendChild(pv);

        var hWrap = el('label', 'scf-eng__field');
        var h = el('input', 'scf-eng__input'); h.type = 'text';
        h.maxLength = plaqueCfg.headlineMax; h.value = item.eng.h;
        h.placeholder = (i18n.headlinePh || 'Headline (max [n] characters)').replace('[n]', plaqueCfg.headlineMax);
        h.addEventListener('input', function () { item.eng.h = h.value; paintPreview(pv, item); });
        hWrap.appendChild(h); block.appendChild(hWrap);

        var sWrap = el('label', 'scf-eng__field');
        var s = el('input', 'scf-eng__input'); s.type = 'text';
        s.maxLength = plaqueCfg.subheadlineMax; s.value = item.eng.s;
        s.placeholder = (i18n.subheadlinePh || 'Optional: Subheadline (max [n] characters)').replace('[n]', plaqueCfg.subheadlineMax);
        s.addEventListener('input', function () { item.eng.s = s.value; paintPreview(pv, item); });
        sWrap.appendChild(s); block.appendChild(sWrap);

        var preset = el('button', 'scf-eng__preset', i18n.useStadiumName || 'Use stadium name'); preset.type = 'button';
        preset.addEventListener('click', function () {
          item.eng.h = item.title.toUpperCase().slice(0, plaqueCfg.headlineMax);
          setVal(h, item.eng.h); paintPreview(pv, item);
        });
        block.appendChild(preset);
        modalBody.appendChild(block);
      });
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeModal() { modal.hidden = true; document.body.style.overflow = ''; }
    root.querySelectorAll('[data-scf-modal-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    root.querySelector('[data-scf-modal-save]').addEventListener('click', function () { closeModal(); render(); });

    /* ---------- price ---------- */
    function renderPrice() {
      var sub = totalBase();
      var pct = discountPercent(state.length, cfg.discountRules);
      var stadiums = stadiumTotal();
      var plaques = plaqueTotal();
      var total = stadiums + plaques;
      var wasTotal = sub + plaques;
      priceEl.innerHTML = '';
      priceEl.appendChild(el('span', 'scf-price__now', money(total, cfg)));
      if (pct > 0) {
        priceEl.appendChild(el('span', 'scf-price__was', money(wasTotal, cfg)));
        priceEl.appendChild(el('span', 'scf-price__save', (i18n.savePrice || 'Save [amount]').replace('[amount]', money(sub - stadiums, cfg))));
      }
    }

    /* ---------- add to cart ---------- */
    function addToCart() {
      errEl.hidden = true;
      atcEl.disabled = true; atcEl.classList.add('is-loading');
      var bundleId = 'scf-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
      var count = String(state.length);
      var items = [];
      state.forEach(function (s) {
        var sp = { '_scf_bundle': bundleId, '_scf_count': count };
        if (plaqueOn && plaqueAvailable) {
          sp['Plaque'] = plaqueCfg.material;
          if (s.eng.h) sp['Plaque Line 1'] = s.eng.h;
          if (s.eng.s) sp['Plaque Line 2'] = s.eng.s;
        }
        items.push({ id: s.variantId, quantity: 1, properties: sp });
        if (plaqueOn && plaqueAvailable) {
          var pp = { '_scf_bundle': bundleId, 'Stadium': s.title };
          if (s.eng.h) pp['Line 1'] = s.eng.h;
          if (s.eng.s) pp['Line 2'] = s.eng.s;
          items.push({ id: plaqueCfg.variantId, quantity: 1, properties: pp });
        }
      });
      fetch(CART_BASE + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'add failed'); }); return r.json(); })
        .then(function () { window.location.href = CART_BASE + 'cart'; })
        .catch(function (e) {
          atcEl.disabled = false; atcEl.classList.remove('is-loading');
          errEl.textContent = e.message || i18n.errGeneric || 'Could not add to cart. Please try again.';
          errEl.hidden = false;
        });
    }
    atcEl.addEventListener('click', addToCart);

    function render() { renderSlots(); renderAdds(); renderPlaque(); renderPrice(); }

    var form = document.querySelector('.m-product-form--main');
    if (form) form.style.display = 'none';
    render();
  }

  function init() {
    document.querySelectorAll('[data-scf]').forEach(function (r) {
      if (!r._scfInit) { r._scfInit = true; SCF(r); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
